import { render } from "./CardQuestion.vue?vue&type=template&id=ed1eb048"
import script from "./CardQuestion.vue?vue&type=script&lang=ts"
export * from "./CardQuestion.vue?vue&type=script&lang=ts"
script.render = render

export default script